(function () {
  var initFindMoreRetailers = function () {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-find-more-retailers-trigger]');

      if (!trigger) {
        return;
      }

      event.preventDefault();

      document.dispatchEvent(
        new CustomEvent('find-more-retailers:open', {
          bubbles: true,
          detail: {
            productId: trigger.dataset.productId,
            productTitle: trigger.dataset.productTitle,
            productUrl: trigger.dataset.productUrl,
            variantId: trigger.dataset.variantId,
            trigger: trigger,
          },
        })
      );
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFindMoreRetailers);
  } else {
    initFindMoreRetailers();
  }
})();
